/* eslint no-bitwise: 1 no-useless-escape: 1 */

function b64ToUint6(nChr) {
    return nChr > 64 && nChr < 91
        ? nChr - 65
        : nChr > 96 && nChr < 123
        ? nChr - 71
        : nChr > 47 && nChr < 58
        ? nChr + 4
        : nChr === 43
        ? 62
        : nChr === 47
        ? 63
        : 0;
}

/* Base64 string to array encoding */
function uint6ToB64(nUint6) {
    return nUint6 < 26
        ? nUint6 + 65
        : nUint6 < 52
        ? nUint6 + 71
        : nUint6 < 62
        ? nUint6 - 4
        : nUint6 === 62
        ? 43
        : nUint6 === 63
        ? 47
        : 65;
}

// Polyfill to run in browser
function base64EncArr(aBytes) {
    const eqLen = (3 - (aBytes.length % 3)) % 3;
    let sB64Enc = '';

    for (let nMod3, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx += 1) {
        nMod3 = nIdx % 3;
        /* Uncomment the following line in order to split the output in lines 76-character long: */
        /*
    if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
    */
        nUint24 |= aBytes[nIdx] << ((16 >>> nMod3) & 24);
        if (nMod3 === 2 || aBytes.length - nIdx === 1) {
            sB64Enc += String.fromCharCode(
                uint6ToB64((nUint24 >>> 18) & 63),
                uint6ToB64((nUint24 >>> 12) & 63),
                uint6ToB64((nUint24 >>> 6) & 63),
                uint6ToB64(nUint24 & 63)
            );
            nUint24 = 0;
        }
    }

    return eqLen === 0
        ? sB64Enc
        : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? '=' : '==');
}

// Polyfill to run in browser
function base64DecToArr(sBase64, nBlockSize) {
    const sB64Enc = sBase64.replace(/[^A-Za-z0-9\+\/]/g, '');
    const nInLen = sB64Enc.length;
    const nOutLen = nBlockSize
        ? Math.ceil(((nInLen * 3 + 1) >>> 2) / nBlockSize) * nBlockSize
        : (nInLen * 3 + 1) >>> 2;
    const aBytes = new Uint8Array(nOutLen);

    for (let nMod3, nMod4, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx += 1) {
        nMod4 = nInIdx & 3;
        nUint24 |= b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << (18 - 6 * nMod4);
        if (nMod4 === 3 || nInLen - nInIdx === 1) {
            for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3 += 1, nOutIdx += 1) {
                aBytes[nOutIdx] = (nUint24 >>> ((16 >>> nMod3) & 24)) & 255;
            }
            nUint24 = 0;
        }
    }

    return aBytes;
}

export const encryptData = async (inputData, armoredPublicKey) => {
    const data = new TextEncoder().encode(inputData);
    const publicKeyStr = armoredPublicKey.substring(27, armoredPublicKey.length - 26);
    const publicKey = base64DecToArr(publicKeyStr);

    const pKey = await window.crypto.subtle.importKey(
        'spki', // can be "jwk" (public or private), "spki" (public only), or "pkcs8" (private only)
        publicKey,
        {
            // these are the algorithm options
            name: 'RSA-OAEP',
            hash: { name: 'SHA-256' }, // can be "SHA-1", "SHA-256", "SHA-384", or "SHA-512"
        },
        false, // whether the key is extractable (i.e. can be used in exportKey)
        ['encrypt'] // "encrypt" or "wrapKey" for public key import or
        // "decrypt" or "unwrapKey" for private key imports
    );

    const encrypted = await window.crypto.subtle.encrypt(
        {
            name: 'RSA-OAEP',
            // label: Uint8Array([...]) //optional
        },
        pKey, // from generateKey or importKey above
        data // ArrayBuffer of data you want to encrypt
    );

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
};
